<template>
  <div class="page user-page">
    <h2 class="page-title">用户管理</h2>
    <div class="filter-card">
      <el-form :model="query" size="small" label-width="68px" class="filter-form">
        <el-row :gutter="12">
          <el-col :xl="5" :lg="6" :md="8" :sm="12" :xs="24">
            <el-form-item label="关键词"><el-input v-model="query.keyword" placeholder="昵称/手机号" clearable /></el-form-item>
          </el-col>
          <el-col :xl="4" :lg="6" :md="8" :sm="12" :xs="24">
            <el-form-item label="角色">
              <el-select v-model="query.role" clearable placeholder="全部">
                <el-option label="普通用户" :value="1" />
                <el-option label="守望者" :value="2" />
                <el-option label="管理员" :value="3" />
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :xl="4" :lg="6" :md="8" :sm="12" :xs="24">
            <el-form-item label="状态">
              <el-select v-model="query.status" clearable placeholder="全部">
                <el-option label="正常" :value="1" />
                <el-option label="禁用" :value="0" />
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :xl="8" :lg="10" :md="12" :sm="24" :xs="24">
            <el-form-item label="注册时间">
              <el-date-picker v-model="dateRange" type="daterange" value-format="yyyy-MM-dd" range-separator="-" start-placeholder="开始日期" end-placeholder="结束日期" clearable />
            </el-form-item>
          </el-col>
          <el-col :xl="4" :lg="6" :md="8" :sm="12" :xs="24">
            <el-form-item class="filter-actions">
              <el-button type="primary" @click="handleSearch">查询</el-button>
              <el-button @click="handleReset">重置</el-button>
            </el-form-item>
          </el-col>
        </el-row>
      </el-form>
    </div>

    <div class="table-card">
      <div class="table-toolbar">
        <span class="table-total">共 {{ total }} 位用户</span>
        <el-button size="small" @click="exportList">导出</el-button>
      </div>
      <el-table :data="tableData" v-loading="loading" border>
        <el-table-column prop="id" label="ID" width="70" />
        <el-table-column label="头像" width="70">
          <template slot-scope="scope"><el-avatar :size="36" :src="scope.row.avatarUrl" /></template>
        </el-table-column>
        <el-table-column prop="nickname" label="昵称" min-width="120" />
        <el-table-column prop="realName" label="真实姓名" width="110" />
        <el-table-column prop="phone" label="手机号" width="130" />
        <el-table-column label="角色" width="100">
          <template slot-scope="scope"><el-tag :type="roleTagType(scope.row.role)">{{ roleText(scope.row.role) }}</el-tag></template>
        </el-table-column>
        <el-table-column label="状态" width="80">
          <template slot-scope="scope"><el-tag :type="scope.row.status === 1 ? 'success' : 'danger'">{{ scope.row.status === 1 ? '正常' : '禁用' }}</el-tag></template>
        </el-table-column>
        <el-table-column prop="integral" label="积分" width="80" />
        <el-table-column label="注册时间" width="170">
          <template slot-scope="scope">{{ formatDateTime(scope.row.registerTime || scope.row.createdAt) }}</template>
        </el-table-column>
        <el-table-column label="最后登录" width="170">
          <template slot-scope="scope">{{ formatDateTime(scope.row.lastLogin) }}</template>
        </el-table-column>
        <el-table-column label="操作" width="220" fixed="right">
          <template slot-scope="scope">
            <div class="action-bar">
              <span class="action-text view" @click="handleView(scope.row)">查看</span>
              <span class="action-text edit" @click="toggleStatus(scope.row)">{{ scope.row.status === 1 ? '禁用' : '启用' }}</span>
              <span class="action-text audit" @click="openChangeRole(scope.row)">改角色</span>
              <span class="action-text delete" @click="handleDelete(scope.row)">删除</span>
            </div>
          </template>
        </el-table-column>
      </el-table>
      <el-pagination background layout="prev, pager, next, total" :total="total" :current-page.sync="query.pageNum" :page-size="query.pageSize" @current-change="loadData" style="margin-top:16px;text-align:right" />
    </div>

    <!-- 查看详情弹框 -->
    <el-dialog title="用户详情" :visible.sync="detailVisible" width="580px">
      <el-descriptions v-if="currentRow" :column="2" border size="small">
        <el-descriptions-item label="ID">{{ currentRow.id }}</el-descriptions-item>
        <el-descriptions-item label="角色"><el-tag :type="roleTagType(currentRow.role)">{{ roleText(currentRow.role) }}</el-tag></el-descriptions-item>
        <el-descriptions-item label="昵称">{{ currentRow.nickname || '-' }}</el-descriptions-item>
        <el-descriptions-item label="真实姓名">{{ currentRow.realName || '-' }}</el-descriptions-item>
        <el-descriptions-item label="手机号">{{ currentRow.phone || '-' }}</el-descriptions-item>
        <el-descriptions-item label="状态"><el-tag :type="currentRow.status === 1 ? 'success' : 'danger'">{{ currentRow.status === 1 ? '正常' : '禁用' }}</el-tag></el-descriptions-item>
        <el-descriptions-item label="积分">{{ currentRow.integral || 0 }}</el-descriptions-item>
        <el-descriptions-item label="注册时间">{{ formatDateTime(currentRow.registerTime || currentRow.createdAt) }}</el-descriptions-item>
        <el-descriptions-item label="最后登录" :span="2">{{ formatDateTime(currentRow.lastLogin) }}</el-descriptions-item>
      </el-descriptions>
      <span slot="footer"><el-button @click="detailVisible = false">关闭</el-button></span>
    </el-dialog>

    <!-- 修改角色弹框 -->
    <el-dialog title="修改角色" :visible.sync="roleVisible" width="400px">
      <el-form :model="roleForm" label-width="80px">
        <el-form-item label="用户">
          <span>{{ roleForm.nickname }}</span>
        </el-form-item>
        <el-form-item label="新角色">
          <el-radio-group v-model="roleForm.role">
            <el-radio :label="1">普通用户</el-radio>
            <el-radio :label="2">守望者</el-radio>
            <el-radio :label="3">管理员</el-radio>
          </el-radio-group>
        </el-form-item>
      </el-form>
      <span slot="footer">
        <el-button @click="roleVisible = false">取消</el-button>
        <el-button type="primary" @click="submitRoleChange">确认修改</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import { fetchUsers, updateUserStatus, updateUserRole, deleteUser } from '@/api'

export default {
  data() {
    return {
      loading: false,
      tableData: [],
      total: 0,
      dateRange: [],
      query: { pageNum: 1, pageSize: 10, keyword: '', role: undefined, status: undefined },
      detailVisible: false,
      roleVisible: false,
      currentRow: null,
      roleForm: { id: null, nickname: '', role: 0 }
    }
  },
  watch: {
    'query.keyword'() { this.handleSearch ? this.handleSearch() : (this.query && (this.query.pageNum=1), this.loadData()) }
  },

  created() { this.loadData() },
  methods: {
    async loadData() {
      this.loading = true
      try {
        const params = { ...this.query }
        if (this.dateRange && this.dateRange.length === 2) {
          params.startTime = this.dateRange[0]
          params.endTime = this.dateRange[1]
        }
        Object.keys(params).forEach(k => { if (params[k] === '' || params[k] === null || params[k] === undefined) delete params[k] })
        const res = await fetchUsers(params)
        this.tableData = res.records || []
        this.total = res.total || 0
      } finally { this.loading = false }
    },
    handleSearch() { this.query.pageNum = 1; this.loadData() },
    handleReset() {
      this.dateRange = []
      this.query = { pageNum: 1, pageSize: 10, keyword: '', role: undefined, status: undefined }
      this.loadData()
    },
    handleView(row) { this.currentRow = row; this.detailVisible = true },
    async toggleStatus(row) {
      const next = row.status === 1 ? 0 : 1
      const action = next === 0 ? '禁用' : '启用'
      try {
        await this.$confirm(`确认${action}用户「${row.nickname || row.id}」吗？`, `${action}确认`, { type: 'warning' })
        await updateUserStatus({ id: row.id, status: next })
        this.$message.success(`已${action}`)
        this.loadData()
      } catch (e) {}
    },
    openChangeRole(row) {
      this.roleForm = { id: row.id, nickname: row.nickname || String(row.id), role: row.role || 1 }
      this.roleVisible = true
    },
    async submitRoleChange() {
      await updateUserRole({ id: this.roleForm.id, role: this.roleForm.role })
      this.$message.success('角色已修改')
      this.roleVisible = false
      this.loadData()
    },
    exportList() {
      const headers = ['ID', '昵称', '真实姓名', '手机号', '角色', '状态', '积分', '注册时间', '最后登录']
      const rows = this.tableData.map(r => [r.id, r.nickname, r.realName, r.phone, this.roleText(r.role), r.status === 1 ? '正常' : '禁用', r.integral, this.formatDateTime(r.registerTime || r.createdAt), this.formatDateTime(r.lastLogin)])
      const csv = [headers, ...rows].map(items => items.map(v => `"${String(v == null ? '' : v).replace(/"/g, '""')}"`).join(',')).join('\n')
      const blob = new Blob(['\ufeff' + csv], { type: 'text/csv;charset=utf-8;' })
      const link = document.createElement('a')
      link.href = URL.createObjectURL(blob)
      link.download = `用户列表_${new Date().toISOString().slice(0, 10)}.csv`
      link.click()
      URL.revokeObjectURL(link.href)
    },
    formatDateTime(v) { return v ? String(v).replace('T', ' ') : '-' },
    roleText(v) { return v >= 3 ? '管理员' : v === 2 ? '守望者' : '普通用户' },
    roleTagType(v) { return v >= 3 ? 'danger' : v === 2 ? 'success' : '' },
    async handleDelete(row) {
      try {
        await this.$confirm('确认删除用户「' + (row.nickname || row.id) + '」吗？删除后不可恢复。', '删除确认', { type: 'warning' })
        await deleteUser(row.id)
        this.$message.success('已删除')
        this.loadData()
      } catch (e) {}
    }
  }
}
</script>

<style scoped>
.filter-form ::v-deep .el-row { width: 100%; }
.filter-form ::v-deep .el-form-item { margin-bottom: 12px; }
.filter-form ::v-deep .el-form-item__content { width: calc(100% - 68px); }
.filter-form ::v-deep .el-input,
.filter-form ::v-deep .el-select,
.filter-form ::v-deep .el-date-editor { width: 100%; }
.filter-form ::v-deep .filter-actions .el-form-item__content { width: 100%; display: flex; gap: 8px; }
.table-toolbar { display: flex; justify-content: space-between; align-items: center; margin-bottom: 12px; }
.table-total { font-size: 13px; color: #606266; }
.action-bar { display: flex; align-items: center; gap: 10px; }
.action-text { cursor: pointer; font-size: 13px; }
.action-text:hover { text-decoration: underline; }
.action-text.view { color: #606266; }
.action-text.edit { color: #409eff; }
.action-text.audit { color: #2f8f5b; }
.action-text.delete { color: #f56c6c; }
</style>
